<template>
    <basic-card>
        <template slot="header">Editation of {{party.displayName}}</template>
        <form-wrapper>
            <form-text-input caption="Name" v-model="party.displayName"/>
        </form-wrapper>

        <template v-for="(partyRole, idx) in party.partyRoles">
          <framed-content :title="partyRoleType(party.partyRoles[idx].partyRoleTypeId).displayName">
            <party-role-part
                    :key="partyRole.id"
                    v-model="party.partyRoles[idx]"
                    :party-role-type="partyRoleType(party.partyRoles[idx].partyRoleTypeId)"
                    @delete="deleteRole(partyRole)"
            />
          </framed-content>
        </template>
        <h1>Add party role</h1>
        <form-wrapper>
            <form-select-input
                caption="Party role to add"
                :options="newPartyRoleTypes"
                v-model="roleToAdd"
            />
        </form-wrapper>
        <simple-horizontal-layout>
            <empty/>
            <empty/>
            <simple-button @press="addRole">Add role</simple-button>
        </simple-horizontal-layout>
        <hr/>
        <simple-button
            @proceed="saveParty" :confirmation-protected="true"
            :protection-message="`Save changes to party ${party.displayName}`">Save party</simple-button>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import {mapGetters} from "vuex";
    import PartyRolePart from "./parts/PartyRolePart";
    import FormSelectInput from "../components/form/FormSelectInput";
    import SimpleButton from "../components/button/SimpleButton";
    import SimpleHorizontalLayout from "../components/layout/SimpleHorizontalLayout";
    import Empty from "../components/layout/Empty";
    import FramedContent from "@/components/layout/FramedContent";
    export default {
        name: "PartyFormCard",
        components: {
          FramedContent,
            Empty,
            SimpleHorizontalLayout,
            SimpleButton, FormSelectInput, PartyRolePart, FormTextInput, FormWrapper, BasicCard},
        props: {
            party: Object
        },
        data: function () {
            return {
                roleToAdd: null
            }
        },
        computed: {
            ... mapGetters({
                partyRoleTypes: "partyRoleTypes/partyRoleTypes",
                partyRoleType: "partyRoleTypes/partyRoleType"
            }),
            newPartyRoleTypes() {
                return this.partyRoleTypes.filter(type => !this.party.partyRoles.map(role => role.partyRoleTypeId).includes(type.id))
                    .map(type => ({id: type.id, name: type.displayName}))
            }
        },
        methods: {
            deleteRole(role) {
                this.party.partyRoles = this.party.partyRoles.filter(partyRole => role.id != partyRole.id);
            },
            addRole() {
                const role = this.partyRoleTypes.filter(type => type.id == this.roleToAdd)[0];

                this.party.partyRoles.push({partyRoleTypeId: role.id, attributeComponent: { values: {}}, validityInterval: null, subclass: 'PartyRole'})
            },
            saveParty() {
                this.$store.dispatch('parties/saveParty', this.party);
            }
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>

</style>